import { useEffect } from "react"
import { useToast } from "components/ui/Toast/useToast"
import { string, oneOf } from "prop-types"
import { Icon, Button } from "@planningcenter/tapestry-react"
import classNames from "classnames"

const Toast = ({ id, message, type }) => {
  const { removeToast } = useToast()

  useEffect(() => {
    const toastTimer = setTimeout(() => {
      removeToast(id)
    }, 6000)

    return () => {
      clearTimeout(toastTimer)
    }
  }, [id, removeToast])

  return (
    <div className="toast">
      <Icon
        className={classNames("toast--icon", { info: type === "info" })}
        color={type === "success" ? "success" : "primary"}
        name={`general.${type === "success" ? "check" : "infoCircle"}`}
      />
      <div className="toast--message">{message}</div>
      <Button
        icon={{ name: "general.x", fill: "grey-5" }}
        variant="naked"
        size="sm"
        radius="circle"
        title="Dismiss toast"
        onClick={() => removeToast(id)}
      />
    </div>
  )
}

Toast.propTypes = {
  id: string.isRequired,
  message: string.isRequired,
  type: oneOf(["success", "info"]).isRequired
}

export default Toast
